import React, { useEffect, useRef, useState } from 'react';
import { handleErrorToast } from '../../shared/Functions';
import { CircularProgress, Modal } from '@material-ui/core';

export function I3PayFacFrame({ urlEndpoint, billingAccountId, getTokenEndpoint, complete, errorToast }) {
    const iframePlugin = useRef<HTMLIFrameElement>(null)
    const [url, setUrl] = useState<string>("");
    const [openPlugin, setOpenPlugin] = useState<boolean>(true)

    useEffect(() => {
        urlEndpoint(billingAccountId, {
            billingAccountId: billingAccountId ?? ""
        })
            .then(urlInfo => {
                setUrl(urlInfo);
            }).catch(err => {
                errorToast(handleErrorToast(err))
                exit(false)
            });
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!url) return;
        window.addEventListener("message", eventListener)

        return () => {
            window.removeEventListener("message", () => {
            })
        }
    }, [url])// eslint-disable-line react-hooks/exhaustive-deps

    const eventListener = (message) => {
        //if (message.origin !== "https://localhost:3001" || typeof message?.data !== "string") return
        if ((!message.origin.includes(".avr-cloud.com") && !message.origin.includes(".i3verticals.cloud")) || typeof message?.data !== "string") return;

        if (message?.data === "i3payfac_cancel") {
            setOpenPlugin(false)
            exit(false)
        }

        if (message?.data.startsWith("token_id|")) {
            getTokenEndpoint(billingAccountId, false, {
                tokenId: message?.data.split("|")[1]
            })
                .then(tokenExchange => {
                    exit(tokenExchange)
                })
                .catch(err => {
                    errorToast(handleErrorToast(err))
                    exit(false)
                })
        }
    }

    const exit = (value) => {
        window.removeEventListener("message", eventListener)
        complete(value)
    }

    const preparePlugin = () => {
        const headScript = document.createElement("script")
        const bodyScript = document.createElement("script")
        headScript.src = url

        headScript.async = false
        iframePlugin.current?.contentWindow?.document.head.appendChild(headScript)

        headScript.onload = () => {
            bodyScript.text = ` 
                        i3Plugins.onPluginCreated = function (type, plugin) {
                        window.parent.postMessage('pluginloaded')
                        if (type == 'payment') {
                            plugin.onEmbed = function (msg) {
                                // Plugin is requesting the id of the element to embed
                                // the plugin in
                                return "divPlugin";
                            }
                            plugin.onCancel = function (msg) {
                                // Handle the user closing the plugin without paying
                                window.parent.postMessage('i3payfac_cancel')
                                this.hide(); // Call the plugin's hide function to hide it
                            }
                            plugin.onTokenize = function (msg) {
                                // Handle the token
                                window.parent.postMessage('token_id|' + msg["token_id"])
                                this.hide(); // Call the plugin's hide function to hide it
                            }
                        }
                    }
            `

            bodyScript.async = false
            iframePlugin.current?.contentWindow?.document.body.appendChild(bodyScript)
        }
    }

    let srcDoc = `
        <html>
            <head>
                <style>
                    .i3plugins-cover-page {
                        opacity: 0.2 !important;
                    }
                </style>
            </head>
            <body>
            </body>
        </html>
    `;

    return (url ?
        <Modal
            open={openPlugin}
            BackdropProps={{
                style: {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                },
            }}
        >
            <div style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
                <iframe
                    style={{ border: "none", width: "100%", height: "100vh" }}
                    id="i3payfacframe"
                    title="i3payfac"
                    srcDoc={srcDoc}
                    ref={iframePlugin}
                    onLoad={preparePlugin}></iframe>
            </div>
        </Modal> : <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
    )

}